import { lazy } from "react";

import { isRouteRestricted } from "../utils/masterBrokerRolePermissions";
import MainLogin from "../Views/MainLogin/MainLogin";
import Dashboard from "../Views/Platform/pages/Dashboard";
import Plans from "../Views/Platform/pages/Plans/Plans";
import Funds from "../Views/Platform/pages/Fund";
import Transaction from "../Views/Platform/pages/Transaction";
import Shares from "../Views/Platform/pages/Report";
import MainPlatform from "../Views/Platform/Main";

const InstitutionalDashboard = lazy(() =>
  import("../Views/Institutional/Dashboard/Dashboard")
);
const PendingDealsOrderActionA = lazy(() =>
  //   import(
  //     "../Views/Institutional/InstitutionalDeals/PendingDeals/PendingDealsOrderActions"
  //   )
  import(
    "../Views/Admin/Deals/InstitutionalDeals/PendingDeals/PendingDealsOrderAction"
  )
);
const PendingDealsOrderAction = lazy(() =>
  import(
    "../Views/Institutional/InstitutionalDeals/PendingDeals/PendingDealsOrderActions"
  )
);
const MarketDeal = lazy(() =>
  import("../Views/Institutional/MarketDeal/MarketDeal")
);
const RequestNewDeal = lazy(() =>
  import("../Views/Institutional/MarketDeal/RequestNewDeal/RequestNewDeal")
);
const RequestNewOffer = lazy(() =>
  import("../Views/Institutional/MarketDeal/RequestNewOffer")
);
const InstitutionalNegotiationRoom = lazy(() =>
  import("../Views/Institutional/MarketDeal/Negotiation/NegotiationRoom")
);
const InstitutionalTransaction = lazy(() =>
  import("../Views/Institutional/Transaction/Transaction")
);
const PendingTransactionAction = lazy(() =>
  import(
    "../Views/Institutional/Transaction/PendingTransactionAction/PendingTransactionAction"
  )
);
const MyDeal = lazy(() => import("../Views/Institutional/MyDeal/MyDeal"));
const AccountsAndCard = lazy(() =>
  import("../Views/Institutional/AccountsAndCard/AccountsAndCard")
);
const ChangePassword = lazy(() =>
  import("../Views/Institutional/ChangePassword/ChangePassword")
);
const ExpiredOrders = lazy(() =>
  import("../Views/Institutional/MyDeal/ExpiredOrders")
);
// const PendingDealsOrderAction = lazy(() => import('../Views/Admin/Deals/InstitutionalDeals/PendingDeals/PendingDealsOrderAction'));

const UserManagementMaster = lazy(() =>
  import("../Views/Institutional/Clients/UserManagement")
);
const BlockshareClientsMaster = lazy(() =>
  import("../Views/Institutional/Clients/BlockshareClientsManagement")
);
const UserManagement = lazy(() =>
  import("../Views/Institutional/Clients/MobileClient/Client")
);
const MemberManagement = lazy(() =>
  import("../Views/Institutional/MemberManagement/MemberManagement")
);
const IndicationOfInterest = lazy(() =>
  import("../Views/IOI/IndicationOfInterest")
);
const SearchIndicationOfInterest = lazy(() =>
  import("../Views/IOI/Search/Search")
);
const PlaceOrder = lazy(() =>
  import("../Views/IOI/PlaceOrder/RequestNewIndication")
);
const RFQ = lazy(() => import("../Views/RFQ/RFQ"));
const InProcessRFQAction = lazy(() =>
  import("../Views/RFQ/InProcess/InProcessRFQAction")
);
const RequestOffer = lazy(() =>
  import("../Views/RFQ/PlaceOffer/RequestNewOffer")
);
const AutoMatchDeal = lazy(() =>
  import("../Views/AutoMatchDeal/AutoMatchDeals")
);

const ContactUs = lazy(() => import("../Views/Website/ContactUs/ContactUs"));

const Report = lazy(() => import("../Views/Report/Report"));

// Protected Route Component (inline)
const ProtectedRoute = ({ children }) => {
  const currentPath = window.location.hash.replace("#", "");

  if (isRouteRestricted(currentPath)) {
    window.location.hash = "/dashboard/select";
    return null;
  }

  return children;
};

const institutional = [
  {
    path: "/dashboard/select",
    exact: true,
    name: "Select Dashboard",
    component: MainLogin,
  },
  {
    path: "/institutional-dashboard/deals-and-market",
    exact: true,
    name: "Institutional Dashboard",
    component: InstitutionalDashboard,
  },
  // {
  //   path: "/shares-platform",
  //   exact: true,
  //   name: "Institutional Dashboard",
  //   component: MainPlatform,
  // },
  // {
  //   path: "/plans",
  //   exact: true,
  //   name: "Institutional Dashboard",
  //   component: Plans,
  // },
  // {
  //   path: "/fund",
  //   exact: true,
  //   name: "Institutional Dashboard",
  //   component: Funds,
  // },
  // {
  //   path: "/transaction",
  //   exact: true,
  //   name: "Institutional Dashboard",
  //   component: Transaction,
  // },
  // {
  //   path: "/report",
  //   exact: true,
  //   name: "Institutional Dashboard",
  //   component: Shares,
  // },



  //   {
  //     path: "/pending-deals-order-actions",
  //     exact: true,
  //     name: "Institutional Dashboard",
  //     component: PendingDealsOrderAction,
  //   },

  {
    path: "/pending-deals-order-action",
    exact: true,
    name: "Institutional Dashboard",
    component: PendingDealsOrderAction,
  },
  {
    path: "/market-deal/deals",
    exact: true,
    name: "Market Deal",
    component: (props) => (
      <ProtectedRoute>
        <MarketDeal {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/request-new-deal",
    exact: true,
    name: "Request New Deal",
    component: (props) => (
      <ProtectedRoute>
        <RequestNewDeal {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/request-new-offer/m-tab",
    exact: true,
    name: "Request New Offer",
    component: (props) => (
      <ProtectedRoute>
        <RequestNewOffer {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/institutional-negotiation-room/m-tab",
    exact: true,
    name: "Institutional Negotiation Room",
    component: (props) => (
      <ProtectedRoute>
        <InstitutionalNegotiationRoom {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/institutional-transaction/tab",
    exact: true,
    name: "Institutional Transaction",
    component: InstitutionalTransaction,
  },
  {
    path: "/pending-institutional-transaction-action/:id",
    exact: true,
    name: "Institutional Transaction",
    component: PendingTransactionAction,
  },

  {
    path: "/my-deal/deals-tab",
    exact: true,
    name: "My Deal",
    component: MyDeal,
  },
  {
    // path: "/accounts-and-card",
    path: "/accounts",
    exact: true,
    name: "Accounts And Card",
    component: AccountsAndCard,
  },
  {
    path: "/change-password",
    exact: true,
    name: "Change Password",
    component: ChangePassword,
  },
  {
    path: "/expired-institutional-orders/:id",
    exact: true,
    name: "Expired Orders ",
    component: ExpiredOrders,
  },

  {
    path: "/user-management-masterclient/:tabkey?",
    exact: true,
    name: "User Management Master",
    component: UserManagementMaster,
  },
  {
    path: "/blockshare-clients-masterclient/:tabkey?",
    exact: true,
    name: "Block Shares Clients Master",
    component: BlockshareClientsMaster,
  },
  {
    path: "/user-management",
    exact: true,
    name: "User Management",
    component: UserManagement,
  },
  {
    path: "/member-management-masterclient",
    exact: true,
    name: "Member Management",
    component: MemberManagement,
  },
  {
    path: `/indication-of-interest/ioi-tab`,
    exact: true,
    name: "Indication Of Interest",
    component: (props) => (
      <ProtectedRoute>
        <IndicationOfInterest {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: `/auto-match-deals/auto-match-tab`,
    exact: true,
    name: "Auto Match Deals",
    component: (props) => (
      <ProtectedRoute>
        <AutoMatchDeal {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/search-order/:id",
    exact: true,
    name: "Search Indication Of Interest",
    component: (props) => (
      <ProtectedRoute>
        <SearchIndicationOfInterest {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/place-order/:id",
    exact: true,
    name: "Place Order",
    component: (props) => (
      <ProtectedRoute>
        <PlaceOrder {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/make-order/:id",
    exact: true,
    name: "Place Order",
    component: (props) => (
      <ProtectedRoute>
        <PlaceOrder {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/request-for-quote/rfq-tab",
    exact: true,
    name: "RFQ",
    component: (props) => (
      <ProtectedRoute>
        <RFQ {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/inprocess-rfq-action/",
    exact: true,
    name: "RFQ",
    component: (props) => (
      <ProtectedRoute>
        <InProcessRFQAction {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/request-offer/:id/:indId",
    exact: true,
    name: "Place Offer",
    component: (props) => (
      <ProtectedRoute>
        <RequestOffer {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/contactus",
    exact: true,
    name: "Contact Us",
    component: ContactUs,
  },
  { path: "/order-report", exact: true, name: "Report", component: Report },
];

export default institutional;
